import {
  createSelector,
} from 'reselect';

import {
  getResourceMappedList,
} from './resources';

export const getClientsPerformance = createSelector(
  getResourceMappedList('clientsPerformance'),
  clients => clients.filter(
    client => (client.last_week_performance > 0)
          || (client.this_week_performance > 0),
  ),
);
